import { render, staticRenderFns } from "./KompetisiOngoing.vue?vue&type=template&id=5cba68de&scoped=true&"
import script from "./KompetisiOngoing.vue?vue&type=script&lang=js&"
export * from "./KompetisiOngoing.vue?vue&type=script&lang=js&"
import style0 from "./Overview.scss?vue&type=style&index=0&id=5cba68de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cba68de",
  null
  
)

export default component.exports